import { render, staticRenderFns } from "./FinancialMovementsTab.vue?vue&type=template&id=6a89d672&scoped=true&"
import script from "./FinancialMovementsTab.vue?vue&type=script&lang=js&"
export * from "./FinancialMovementsTab.vue?vue&type=script&lang=js&"
import style0 from "./FinancialMovementsTab.vue?vue&type=style&index=0&id=6a89d672&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a89d672",
  null
  
)

export default component.exports